<h3>
    <p  [ngStyle]="{'text-align':feature.textAlign}" >{{feature.label}}</p>
</h3>

<p style="white-space: pre-wrap;"  [style.text-align]="feature.textAlign" >{{feature.description}}</p>